/* Craftybella PDP — photo uploads + Qikify suppression.
   Loads after cb-pdp.js and registers itself on CB.mods. */
window.CB = window.CB || {};
(function (CB) {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function toast(m) { if (CB.toast) CB.toast(m); }

  /* ---------- Photo uploads ----------
     Shopify carries an uploaded file as a line item property whose value is a
     link, so the note and the photos arrive together on the order. Two things
     decide whether that actually works on a phone:
       1. /cart/add.js cannot carry a file, so productForm() falls back to a
          real multipart POST as soon as a photo is attached.
       2. A current phone camera writes 4-12MB per shot. Three of those over
          Indian mobile data is a long wait and a good chance of a failed add,
          so each one is redrawn to at most PHOTO_MAX px on its long edge and
          re-encoded as JPEG. That usually turns 8MB into under 1MB with no
          visible loss at print size. If any part of that path is unavailable
          (HEIC, an older browser, no DataTransfer) the original file is sent
          untouched rather than dropped.                                      */
  var PHOTO_MAX = 2000;
  var PHOTO_Q = 0.82;
  var PHOTO_LIMIT = 20 * 1024 * 1024;   /* Shopify's own per-file ceiling */

  function fileSize(n) {
    return n >= 1048576 ? (n / 1048576).toFixed(1) + ' MB' : Math.round(n / 1024) + ' KB';
  }

  function shrinkPhoto(file) {
    return new Promise(function (resolve) {
      if (!file || !/^image\//i.test(file.type)) return resolve(file);
      if (/heic|heif/i.test(file.type)) return resolve(file);
      if (file.size <= 600 * 1024) return resolve(file);
      if (typeof DataTransfer === 'undefined' || !HTMLCanvasElement.prototype.toBlob) return resolve(file);

      var url = URL.createObjectURL(file);
      var img = new Image();
      var settled = false;
      function finish(f) {
        if (settled) return;
        settled = true;
        URL.revokeObjectURL(url);
        resolve(f);
      }
      setTimeout(function () { finish(file); }, 15000);
      img.onerror = function () { finish(file); };
      img.onload = function () {
        try {
          var w = img.naturalWidth, h = img.naturalHeight;
          var k = Math.min(1, PHOTO_MAX / Math.max(w, h));
          var c = document.createElement('canvas');
          c.width = Math.max(1, Math.round(w * k));
          c.height = Math.max(1, Math.round(h * k));
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          c.toBlob(function (blob) {
            if (!blob || blob.size >= file.size) return finish(file);
            try {
              finish(new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg',
                              { type: 'image/jpeg', lastModified: Date.now() }));
            } catch (e) { finish(file); }
          }, 'image/jpeg', PHOTO_Q);
        } catch (e) { finish(file); }
      };
      img.src = url;
    });
  }

  function photos(root) {
    $$('[data-cb-photo]', root).forEach(function (inp) {
      var tile = inp.closest('.cb-photo');
      var nameEl = tile ? $('[data-cb-photo-name]', tile) : null;
      var fallback = nameEl ? nameEl.textContent : '';

      function state(v) { if (tile) tile.setAttribute('data-cb-state', v); }
      function mark(ok, bad) {
        if (!tile) return;
        tile.classList.toggle('is-set', !!ok);
        tile.style.opacity = '';
        tile.style.borderStyle = bad ? 'solid' : '';
        tile.style.borderColor = bad ? '#B4562F' : '';
      }

      inp.addEventListener('change', function () {
        var f = inp.files && inp.files[0];
        if (!f) {
          state('empty'); mark(false, false);
          if (nameEl) nameEl.textContent = fallback;
          return;
        }

        state('busy');
        if (tile) tile.style.opacity = '.6';
        if (nameEl) nameEl.textContent = 'Preparing\u2026';

        shrinkPhoto(f).then(function (out) {
          if (out !== f) {
            try {
              var dt = new DataTransfer();
              dt.items.add(out);
              inp.files = dt.files;
            } catch (e) { /* keep whatever the input already holds */ }
          }
          var kept = (inp.files && inp.files[0]) || f;

          if (kept.size > PHOTO_LIMIT) {
            state('bad'); mark(false, true);
            if (nameEl) nameEl.textContent = 'Too large (' + fileSize(kept.size) + ')';
            toast('That photo is over 20 MB. Please choose a smaller one.');
            return;
          }
          state('ok'); mark(true, false);
          if (nameEl) nameEl.textContent = kept.name + ' \u00b7 ' + fileSize(kept.size);
        });
      });
    });
  }

  /* ---------- Third-party option widget ----------
     Qikify (Tepo Product Options) injects itself into every product page:
     it adds .tcustomizer-hide-button to the theme's add-to-cart, drops in its
     own #tcustomizer-add clone next to it (one per add-to-cart it finds, so the
     sticky bar earns a second one), and renders a duplicate option form in
     #tcustomizer-app. Its clone is type="button" and submits through its own
     code, so the native properties[] fields in this template never reach the
     cart while it is running.

     This template collects the personalisation itself, so on pages that opt in
     we put our own button back and take the duplicate out. Everything else on
     the store is untouched. Qikify injects late and more than once, hence the
     observer with a stop.                                                  */
  function soloOptions(root) {
    if (!root.hasAttribute('data-cb-solo-options')) return;

    function sweep() {
      $$('.tcustomizer-hide-button', root).forEach(function (el) {
        el.classList.remove('tcustomizer-hide-button');
        el.style.removeProperty('display');
      });
      $$('#tcustomizer-add, .tcustomizer-overlap-button', root).forEach(function (el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      var app = document.getElementById('tcustomizer-app');
      if (app) app.setAttribute('hidden', 'hidden');
      document.body.classList.remove('tcustomizer-enabled');
    }

    sweep();
    var obs = new MutationObserver(sweep);
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); sweep(); }, 12000);
  }


  /* Deferred scripts run after the document is parsed, so cb-pdp.js may already
     have finished its own init by the time this file executes. Boot ourselves
     instead of relying on load order; the guard keeps it to once per block. */
  function boot() {
    $$('[data-cb-pdp]').forEach(function (root) {
      if (root.__cbPhotos) return;
      root.__cbPhotos = true;
      try { soloOptions(root); photos(root); } catch (e) {}
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})(window.CB);
